// import apiempresaweb from '@/services/api-varejoweb';

export default {
  namespaced: true,

  state: {
    list: [],
    count: 0,
    cacheQuery: {},
  },

  getters: {
    list: (state) => state.list,
    count: (state) => {
      if (state.count > 0) return true;
      return false;
    },
    cacheQuery: (state) => (query) => {
      let bool = true;
      if (Object.keys(state.cacheQuery).length > 0) {
        if (JSON.stringify(state.cacheQuery.where) === JSON.stringify(query)) {
          bool = false;
        }
      } else {
        bool = true;
      }
      return bool;
    },
  },

  // NUNCA ALTERAR state DIRETAMENTE EM ACTIONS
  actions: {
    async count({ commit, getters }, {
      where, ...params
    } = {}) {
      console.log('detro', where, params);
      if (getters.cacheQuery(where)) {
        commit('SET_cacheQuery', { where, ...params });
        
        commit('SET_count', Number(200));
      } else {
        commit('SET_cacheQuery', { ...params });
      }
    },
  },

  // APENAS O MUTATION FAZ ALTERAÇÕES NO STATE
  mutations: {
    SET_LIST(state, list) {
      state.list = list ?? [];
    },
    SET_cacheQuery(state, query) {
      state.cacheQuery.where = query.where ?? state.cacheQuery.where;
      state.cacheQuery.offset = query.offset;
    },
    SET_count(state, count) {
      state.count = count ?? 0;
    },
    CLEAR_count(state) {
      state.count = 0;
    },
    CLEAR_vuex(state) {
      state.cacheQuery = {};
      state.count = 0;
    },
  },
};
